"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const reactstrap_1 = require("reactstrap");
exports.Breadcrumbs = (props) => (React.createElement("div", { className: "app-header-breadcrumbs" },
    React.createElement(reactstrap_1.Breadcrumb, null, props.list.map((item, index) => (React.createElement(reactstrap_1.BreadcrumbItem, { key: index }, renderBreadcrumbContent(item)))))));
exports.Breadcrumbs.displayName = 'Breadcrumbs';
const renderBreadcrumbContent = (item) => {
    if (typeof item === 'string') {
        return React.createElement("span", null, item);
    }
    return item;
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Breadcrumbs.tsx
// module id = 240
// module chunks = 0